import {useEffect, useRef} from 'react';
import {UseBannerTrackingParams} from './types';

export const useBannerTracking = ({
	banners,
	currentSlideIndex,
	interleavedBanners,
	isVisible,
}: UseBannerTrackingParams) => {
	const impressionsFiredRef = useRef(false);

	const trackBannerBeacon = (url: string) => {
		fetch(url, {
			method: 'POST',
			body: '',
		}).catch(() => {});
	};

	useEffect(() => {
		if (banners && banners.length > 0 && !impressionsFiredRef.current) {
			impressionsFiredRef.current = true;
			const impressionUrls = banners.map(banner => banner.impression_url);
			Promise.all(
				impressionUrls.map(url =>
					fetch(url, {
						method: 'POST',
						body: '',
					}).catch(() => {}),
				),
			);
		}
	}, [banners]);

	useEffect(() => {
		if (isVisible && interleavedBanners[currentSlideIndex]) {
			const currentBanner = interleavedBanners[currentSlideIndex];
			trackBannerBeacon(currentBanner.view_url);
		}
	}, [currentSlideIndex, interleavedBanners, isVisible]);

	const handleBannerClick = (clickUrl: string) => {
		trackBannerBeacon(clickUrl);
	};

	return {handleBannerClick};
};

export type {UseBannerTrackingParams} from './types';
